import React, { memo, useMemo, useState } from 'react';
import classes from './upperHeader.css';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from '@magento/venia-drivers';
import StoreSwitcher from './storeSwitcher';
import UpperHeaderShippingMessage from './components/upperHeaderShippingMessage';
import { useLocation } from 'react-router-dom';
import { ChevronLeft } from 'react-feather';
import Lock from '@magento/venia-ui/venia-static/icons/lock.svg';
import { MEDIA_MAX_MOBILE } from '@magento/venia-ui/lib/helpers/mediaQuery';
import useMediaQuery from 'react-use-media-query-hook';
import StoreSchedule from "./storeSchedule";
import Arrow from '@magento/venia-ui/venia-static/icons/chevron.svg';
import LocationIcon from "@magento/venia-ui/venia-static/icons/location.svg";
import BBLink from "../BBLink";
var UpperHeader = props => {
  var {
    headerType
  } = props;
  var {
    formatMessage
  } = useIntl();
  var [schedule, setSchedule] = useState('init');
  var location = useLocation();
  var isMaxMobile = useMediaQuery(MEDIA_MAX_MOBILE);
  var history = useHistory();
  var isSecureHeader = useMemo(() => {
    return !location || !(location.pathname.includes('/checkout') || location.pathname.includes('/success'));
  }, [location]);
  return /*#__PURE__*/React.createElement("div", {
    className: headerType === 'headerV1' ? classes.upperHeaderV1 : classes.upperHeader,
    style: !isSecureHeader ? {
      paddingLeft: '4.688rem',
      paddingRight: '4.125rem'
    } : {}
  }, isSecureHeader ? /*#__PURE__*/React.createElement("div", {
    className: classes.storeSchedules,
    onClick: () => {
      setSchedule(schedule === 'openSchedule' ? 'closeSchedule' : 'openSchedule');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: LocationIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.locationName
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'upperHeader.findOurStores',
    defaultMessage: 'Find our Stores'
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("img", {
    src: Arrow,
    className: schedule === 'openSchedule' ? classes.locationArrow : classes.locationArrowDown,
    alt: 'arrow'
  })), schedule === 'openSchedule' && /*#__PURE__*/React.createElement(StoreSchedule, {
    setSchedule: setSchedule,
    schedule: schedule
  })) : !isMaxMobile ? /*#__PURE__*/React.createElement("button", {
    style: {
      height: '1.875rem'
    },
    onClick: () => {
      location.pathname === '/success' ? history.push('/') : history.push('/cart');
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.backToCart
  }, /*#__PURE__*/React.createElement(ChevronLeft, null), /*#__PURE__*/React.createElement("p", null, location.pathname === '/success' ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'miniCart.continueShopping',
    defaultMessage: 'Continue Shopping'
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'checkout.backToCart',
    defaultMessage: 'Back To Cart'
  })))) : null, /*#__PURE__*/React.createElement(UpperHeaderShippingMessage, null), !isSecureHeader && !isMaxMobile && /*#__PURE__*/React.createElement("div", {
    className: classes.secureCheckout
  }, /*#__PURE__*/React.createElement("img", {
    src: Lock,
    alt: 'lock'
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'priceSummary.checkoutButton',
    defaultMessage: 'Secure Checkout'
  }))), isSecureHeader && /*#__PURE__*/React.createElement("div", {
    className: classes.rightNavigation
  }, /*#__PURE__*/React.createElement(BBLink, {
    to: "/".concat(formatMessage({
      id: 'header.contactus',
      defaultMessage: 'contact-us'
    }))
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'Contact Us',
    defaultMessage: 'Contact Us'
  })), /*#__PURE__*/React.createElement(StoreSwitcher, {
    opposite: true
  })));
};
export default memo(UpperHeader);